<template>
  <data-chip
    :text="statusText(status)"
    :color="statusColor(status)"
    :iconLeft="statusIcon(status)"
    :small="small"
  >
  </data-chip>
</template>

<script>
import DataChip from "@/components/_systemwide/DataChip.vue";
export default {
  name: "attendance-status-chip",
  components: {
    DataChip,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    statusText(statusId) {
      switch (statusId) {
        case "1":
          return "Anwesend";
        case "2":
          return "Entschuldigt";
        case "3":
          return "Unentschuldigt";
        default:
          return "Fehler";
      }
    },
    statusIcon(statusId) {
      switch (statusId) {
        case "1":
          return "check-circle";
        case "2":
          return "close-circle";
        case "3":
          return "close-octagon";
        default:
          return "alert";
      }
    },
    statusColor(statusId) {
      switch (statusId) {
        case "1":
          return "green";
        case "2":
          return "orange";
        case "3":
          return "red";
        // case "toBeReviewed":
        //   return "purple";
        // case "closed":
        //   return "green";
        default:
          return "grey";
      }
    },
  },
};
</script>
